import { useUpdateAtom } from "jotai/utils";
import { useEffect, useRef } from "react";
import { scrollRefAtom, sideNavOnAtom } from "../jotai/atoms";
import { Point2D } from "../types";
import { gridToPixelSize } from "../utils/gridPosition";
import { DEFAULT_SPACE_SIZE, SIDE_NAV_WIDTH } from "../consts";
import { useAtom } from "jotai";
import { useOnce } from "./useOnce";
export const DEFAULT_SPACE_SIZE_PIXELS = gridToPixelSize(DEFAULT_SPACE_SIZE);

export default function useSpaceScroll() {
  // Track scroll position with atom
  const scroll = useRef<Point2D>({ x: 0, y: 0 });
  const setScrollRefAtom = useUpdateAtom(scrollRefAtom);
  const [sideNavOn] = useAtom(sideNavOnAtom);

  useEffect(() => {
    setScrollRefAtom(scroll);
  }, [scroll, setScrollRefAtom]);

  useEffect(() => {
    function onScroll() {
      scroll.current.x = window.scrollX;
      scroll.current.y = window.scrollY;
    }
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  // Start at center
  useOnce(() => {
    let x = (DEFAULT_SPACE_SIZE_PIXELS.width - window.innerWidth) / 2;
    if (sideNavOn) {
      x += 0.5 * SIDE_NAV_WIDTH;
    }

    window.scrollTo(x, 0);

    // set inital location
    // setAudioListenerLocation(
    //   document.documentElement.scrollLeft + window.innerWidth / 2,
    //   document.documentElement.scrollTop + window.innerHeight / 2,
    //   INITIAL_EAR_HEIGHT
    // );
  });
}
